var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelivered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0224 0.290924H12.8749C12.7141 0.290924 12.5614 0.364795 12.4629 0.491196L5.69467 9.06516L2.44927 4.953C2.40017 4.89067 2.3376 4.84027 2.26623 4.80558C2.19487 4.7709 2.11658 4.75283 2.03723 4.75273H0.88977C0.779785 4.75273 0.719046 4.87913 0.786351 4.9645L5.28263 10.6608C5.49275 10.9267 5.89658 10.9267 6.10834 10.6608L14.1258 0.501046C14.1931 0.417326 14.1324 0.290924 14.0224 0.290924Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivered);
export default __webpack_public_path__ + "static/media/delivered.93625351f6e0bd32ee8031331a65c2a7.svg";
export { ForwardRef as ReactComponent };